// @flow
import * as React from 'react';

import PreviewContext from '../context/PreviewContext';

export default function usePreviewContext() {
  return React.useContext(PreviewContext);
}
